import React, { useState, useEffect } from "react";
import "../css/otpVerification.css";

const OtpVerification = ({
  isOpen,
  onClose,
  onSubmit,
  isOtpDisabled,
  resendOtpHandler,
  title,
  description,
  isResend = true,
  btnTxt,
  // isSessionVerification = false,
}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
  const [err, setErr] = useState(false);

  // Update the countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secondsLeft).padStart(
      2,
      "0"
    )}`;
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input box when a digit is entered
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fullOtp = otp.join("");
    if (fullOtp.length !== 4) {
      setErr("Fill all the otp fields");
      return;
    }
    onSubmit(fullOtp);
    setOtp(["", "", "", ""]);
  };

  if (!isOpen) return null;

  const callResendOtp = () => {
    setTimeLeft(300);
    resendOtpHandler();
  };

  return (
    <div className="general modal-overlay">
      <div className="modal-content otp-verification-box">
        <button className="close-icon" onClick={onClose}>
          ×
        </button>
        <h2>{title}</h2>
        <p>{description}</p>
        {err && <p className="error form-error">{err} </p>}
        <form onSubmit={handleSubmit}>
          <div className="otp-input-container">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="number"
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                maxLength="1"
                className="otp-input"
                autoFocus={index === 0}
                inputMode="numeric"
              />
            ))}
          </div>

          {isResend && (
            <div>
              <p className="timer-text">
                You can resend code {formatTime(timeLeft)}
              </p>
              {timeLeft === 0 && (
                <p className="timer-resend" onClick={callResendOtp}>
                  Resend
                </p>
              )}
            </div>
          )}
          {/* {isSessionVerification && (
            <button className="submit-btn forgot-pass-btn mr-2">No Show</button>
          )} */}
          <button
            type="submit"
            className="submit-btn forgot-pass-btn"
            disabled={otp.includes("") || isOtpDisabled}
          >
            {isOtpDisabled ? "Please wait..." : btnTxt}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OtpVerification;
